import {useEffect} from 'react'
import {useLocation} from 'react-router'

import {useSessionUpdatedEventListener} from '@product-web/shared--auth--session/store'
import {useFlags} from '@product-web/shared--flags'
import {createPersistedState} from '@product-web/shared--web-platform/persisted-state'
import {localStorage} from '@product-web/shared--web-platform/storage/local'

import {bff} from '../bff-hooks'

type RouAdoptionPromptState = 'hidden' | 'visible' | 'viewed'

const [usePersistedState, clearPersistedState] = createPersistedState(
    'rou-adoption-prompt',
    localStorage,
)

const ROU_ADOPTION_PATHS = ['/reimbursements']

export const useRouAdoption = () => {
    const {reimbursementOnlyUsersV2} = useFlags()
    const {data} = bff.adoption.rouAdoptionPrompt.getRouAdoptionPrompt.useQuery(undefined, {
        enabled: !!reimbursementOnlyUsersV2,
    })

    const isPromptVisible = data?.isVisible
    const location = useLocation()

    useSessionUpdatedEventListener(() => {
        clearPersistedState()
    })

    const [rouAdoptionPromptState, setRouAdoptionPromptState] =
        usePersistedState<RouAdoptionPromptState>('rouAdoptionPromptState', 'hidden')

    const isVisibleLocation = ROU_ADOPTION_PATHS.some((p) => location.pathname.startsWith(p))

    useEffect(() => {
        if (
            isVisibleLocation &&
            isPromptVisible &&
            rouAdoptionPromptState === 'hidden' &&
            reimbursementOnlyUsersV2
        ) {
            setRouAdoptionPromptState('visible')
        }
    }, [
        isPromptVisible,
        isVisibleLocation,
        reimbursementOnlyUsersV2,
        rouAdoptionPromptState,
        setRouAdoptionPromptState,
    ])

    const setRouAdoptionPromptViewed = () => {
        setRouAdoptionPromptState('viewed')
    }

    return {
        shouldShowRouAdoptionPrompt: rouAdoptionPromptState === 'visible' && isVisibleLocation,
        minSavingPercentage: data?.minSavingPercentage ?? 0,
        setRouAdoptionPromptViewed,
    }
}
